module.exports = __webpack_public_path__ + "static/media/agile.c5d75748.png";